/* eslint-disable react/no-array-index-key */

import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
/**
 *
 * ListFilters
 *
 */
import cn from 'classnames'
import React from 'react'

import LabelWrapper from '../LabelWrapper'

const styles = theme => ({
  formControl: {
    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    color: `${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`} !important`,
    height: '36px',
    minWidth: '100px',
    '& .MuiInputBase-root': {
      display: 'flex',
      justifyContent: 'stretch',
      height: '36px',
      lineHeight: 1,
    },
    '&:focus': {
      background: 'none',
    },
    '& .MuiSelect-root': {
      display: 'flex',
      alignItems: 'center',
      padding: '0 30px 0 10px',
      height: '34px !important',
    },
  },
  fullWidth: {
    width: '100%',
  },
  border: {
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    borderRadius: '4px',
    overflow: 'hidden',
  },
  selectEmpty: {
    marginTop: theme.spacing(8),
  },
  stgSelect: {
    background: 'transparent',
    fontSize: '14px',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& div > div': {
      width: 'calc(100% - 30px)',
      padding: '10px 20px 8px 10px',
      lineHeight: 1,
      '&:focus': {
        background: 'none',
      },
    },
  },
  disabled: {
    backgroundColor: `var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`,
    borderColor: `var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`,
    color: `var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`,
    opacity: theme.inputField.inputDisabledOpacity,
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
  dropdown: {
    '& .has-error $formControl': {
      borderColor: theme.status.errorColor,
      backgroundColor: theme.status.errorBG,
    },
  },
  menuItem: {
    fontSize: theme.typography.fontSizeSm,
  },
})

/* eslint-disable react/prefer-stateless-function */
class DropDownOne extends React.Component {
  handleChange = event => {
    const { value } = event.target
    const { data, onChange } = this.props
    const index = data.findIndex(item => item.value === value)
    onChange(data[index])
  }

  render() {
    const {
      classes,
      className,
      label,
      isMandatory,
      isError,
      displayEmpty,
      data,
      errorMessage,
      onChange,
      optionValue,
      optionLabel,
      selected,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      disabled,
      icon,
      justify,
      fullWidth,
      isLabelInline,
      errorText,
      helperText,
      id,
      isRequired,
      isToolTip,
      multipleFields,
      noMobile,
      notWrapper,
      noWrap,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      withBorder,
      withDivider,
      ...rest
    } = this.props
    return (
      <LabelWrapper
        className={cn(classes.dropdown, className)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        errorText={errorMessage || errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired || isMandatory}
        isToolTip={isToolTip}
        justify={justify}
        label={label}
        multipleFields={multipleFields}
        noMobile={noMobile}
        notWrapper={notWrapper}
        noWrap={noWrap}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        <FormControl
          className={cn(classes.formControl, withBorder && classes.border, fullWidth && classes.fullWidth)}
          error={isError}
        >
          <Select
            value={selected}
            onChange={this.handleChange}
            className={classes.stgSelect}
            displayEmpty={displayEmpty && displayEmpty}
            native={false}
            style={customWidth ? { width: `${customWidth}px` } : {}}
            disabled={disabled}
            classes={{ disabled: classes.disabled }}
            {...rest}
          >
            {Array.isArray(data) &&
              data.map((option, key) => (
                <MenuItem
                  key={`itemIn${
                    // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                    key
                  }`}
                  value={optionValue ? option[optionValue] : option.value}
                  className={classes.menuItem}
                >
                  {optionLabel ? option[optionLabel] : option.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </LabelWrapper>
    )
  }
}

DropDownOne.defaultProps = {
  onChange: () => {},
  customWidth: null,
  data: [],
  selected: '',
  displayEmpty: true,
  label: '',
  isMandatory: false,
  isError: false,
  icon: false,
  fullWidth: false,
  isLabelInline: false,
  notWrapper: true,
  border: false,
  withBorder: true,
}

const DropDownOneComponent = withStyles(styles)(DropDownOne)
DropDownOneComponent.displayName = 'DropDownOne'
export default DropDownOneComponent
